module.exports = __webpack_public_path__ + "img/tham-my-vien.5fbc7c52.png";